var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('Mail',{ref:"mail",attrs:{"emails_list":_vm.mandat.emails,"attached_objects":_vm.object,"free_mail":false,"body":_vm.body,"subject":_vm.subject},on:{"close":function($event){return _vm.$emit('close', $event)}}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }